import { Component } from 'react';

export class Index extends Component {
  componentDidMount() {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.channeltuoke';
  }

  render() {
    return null;
  }
}

export default Index;
